<template>
  <div>
    <table border="1" class="table" bordercolor="#ebeef4">
      <tr style="background:#F3E8E3">
        <th>编号</th>
        <th>项目</th>
        <th>记账月份</th>
        <th>实际消耗月份</th>
        <th>达人账号</th>
        <!-- <th>达人ID</th> -->
        <th>投放周期</th>
        <th>下单金额</th>
        <th>服务费比例(小数)</th>
        <th>返点金额</th>
      </tr>
      <template v-for="(items,ind) in dataInfo.order.list">
        <tr v-for="(item,index) in items.row" :key="ind+'tr'+index+'row'">
          <td>{{index+1}}</td>
          <td>{{item.project_name_second}}</td>
          <td>{{item.month}}</td>
          <td>{{item.order_original_month}}</td>
          <td>{{item.internet_celebrity_name}}</td>
          <!-- <td>{{item.internet_celebrity_id}}</td> -->
          <td>{{item.launch_start_date}}</td>
          <td style="text-align: right;">
            <span>{{$formatNum(item.final_amount)}}</span>
          </td>
          <td>
            {{item.percentage_of_service_charge}}
          </td>
          <td style="text-align: right;">
            {{$formatNum(item.return_point_amount)}}
          </td>
        </tr>
        <tr style="background:#f4f7fa" :key="ind+'tr1'">
          <td colspan='6'>{{items.sort_month}}小计</td>
          <td style="text-align: right;">{{$formatNum(items.final_amount)}}</td>
          <td></td>
          <td style="text-align: right;">{{$formatNum(items.return_point_amount)}}</td>
        </tr>
        <tr v-if="ind + 1 == dataInfo.order.list.length" :key="ind+'tr2'">
          <td colspan='6' style="color:#393d64;font-weight:500;">总金额</td>
          <td colspan='3' style="text-align: right;">{{$formatNum(dataInfo.order.total.return_point_amount)}}</td>
        </tr>
      </template>
    </table>
  </div>
</template>
<script>
export default {
  props: ['dataInfo'],
}
</script>
<style lang="scss" scoped>
@import "../statementTemplate/statementDetail.scss";
</style>
<style lang="scss">
.statementToast {
  .el-form-item__content {
    font-size: 12px !important;
  }
  .el-form-item--mini.el-form-item {
    margin-bottom: 0 !important;
  }
  .table .el-input__inner {
    padding: 0 !important;
    text-align: center !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/newBilling/examine/mcnStatement.vue